import { atom, useAtom } from 'jotai';
import { ITrackingSettingsData } from 'types';

const defaultValue: ITrackingSettingsData = {
  safeId: '',
  isPrivacyMode: true,
};

const trackingSettingsAtom = atom<ITrackingSettingsData>(defaultValue);

export const useSafeSettings = () => {
  const [safeSettings, setSafeSettings] = useAtom(trackingSettingsAtom);

  return {
    safeSettings,
    setSafeSettings,
  };
};
